import { render } from "./TemplateSidebar.vue?vue&type=template&id=7d780899&ts=true"
import script from "./TemplateSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./TemplateSidebar.vue?vue&type=style&index=0&id=7d780899&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/templates/components/TemplateSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d780899"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d780899', __exports__)) {
    api.reload('7d780899', __exports__)
  }
  
  module.hot.accept("./TemplateSidebar.vue?vue&type=template&id=7d780899&ts=true", () => {
    api.rerender('7d780899', render)
  })

}


export default __exports__